import React, { useCallback, useState } from "react";
import { InView } from "react-intersection-observer";

import { useStore } from "../../store";
import {
  CorporateSnapshots,
  ScrollIndicator,
  VimeoContainer,
} from "../../components";
import { AMNESTY_REPORT_URL } from "../../utils";

export default function CorporateStructure() {
  const [showChart, setShowChart] = useState(false);
  const {
    media: { corporate: corporateVideos },
  } = useStore(
    useCallback((state) => {
      return state.data.media;
    }, [])
  );

  return (
    <div className="mny-navbar">
      <InView
        threshold={0}
        initialInView={true}
        onChange={(inView) => {
          !inView && setShowChart(true);
          inView && setShowChart(false);
        }}
      >
        <VimeoContainer
          url={corporateVideos[0].src}
          className="mb2 full-height-minus-navbar"
        >
          <div className="flex flex-row col-12 justify-around">
            <ScrollIndicator
              text="See more"
              className="absolute"
              style={{ bottom: `50px` }}
            />
          </div>
        </VimeoContainer>
        <div className="flex flex-column center items-center my4 col-12">
          <div className="lg-col-8 md-col-9 sm-col-12 px2">
            <div className="h0 mb2">Inside NSO Group's Corporate Structure</div>
            <div className="flex flex-row flex-wrap justify-between">
              <div className="color-gray h2 xs-col-12 md-col-5 left-align mt2">
                Click through the timeline below to explore the corporate
                network within which the NSO Group is nested.
              </div>
              <div className="color-gray h2 xs-col-12 md-col-5 left-align mt2">
                Read{" "}
                <span className="inverted" style={{ borderRadius: `2px` }}>
                  <a
                    href={AMNESTY_REPORT_URL}
                    target="__blank"
                    className="color-primary"
                    style={{ padding: `2px` }}
                  >
                    Amnesty International's report
                  </a>
                </span>{" "}
                which tracks investment in NSO and its corporate structure.
              </div>
            </div>
          </div>
        </div>
      </InView>

      <CorporateSnapshots
        enableScroll={false}
        showChart={showChart}
        className=""
      />
    </div>
  );
}
